export const STATIONS = "Pick Stations";
export const PICK_RATE = "PPH";
export const PICK_TAKT_TIME = "Takt (sec)";
export const POD_DWELL_TIME = "Dwell Time (sec)";
export const POD_GAP = "Pod Gap (sec)";
export const ASSOCIATE = "Associate";
export const STATION_STATUS = "Station Status";
export const PICKED_PACKAGE_COUNT = "Picked";
export const PILE_ON = "Pile On";

export const AR_WORKSTATION_METRICS_TABLE_COLUMNS = [
    STATIONS,
    PICK_RATE,
    PICK_TAKT_TIME,
    POD_DWELL_TIME,
    POD_GAP,
    ASSOCIATE,
    STATION_STATUS,
    PICKED_PACKAGE_COUNT,
    PILE_ON
]



// WEBPACK FOOTER //
// ./src/components/workstationMetrics/WorkstationMetricsTableColumns.js